<template>
  <van-pull-refresh
    v-model="refreshing"
    class="page-pull-refresh"
    @refresh="onRefresh"
  >
    <div class="device-management">
    <!--section class="page-hero">
      <div class="page-hero__copy">
        <span class="page-hero__eyebrow">设备总览</span>
        <h2>梯口设备管理中心</h2>
        <p>统一查看设备在线状态、码头归属与摄像头数量，手机端聚焦操作，桌面端提升扫描效率。</p>
      </div>
      <div class="page-hero__meta">
        <span class="meta-pill">设备总数 {{ devices.length }}</span>
        <span class="meta-pill meta-pill--soft">AI 在线 {{ filteredDevices.filter(item => item.isOnlineAi).length }}</span>
      </div>
    </section-->

    <div class="toolbar-card">
      <div class="search-bar-row">
        <van-search
          v-model="searchKeyword"
          placeholder="搜索设备编号/名称"
          @search="onSearch"
          @clear="onClear"
          show-action
          class="device-search"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-button
          v-if="isSuperAdmin"
          type="primary"
          size="small"
          icon="plus"
          class="add-device-icon-btn"
          @click="showAddDevice = true"
        >
          <span class="btn-text">新增设备</span>
        </van-button>
      </div>
    </div>

    <div class="device-list">
      <van-card
        v-for="device in filteredDevices"
        :key="device.id"
        class="device-card"
        @click="isSuperAdmin ? onDeviceClick(device) : null"
      >
        <template #title>
          <div class="device-header">
            <div class="device-info">
              <h3 class="device-id">{{ device.deviceName }}</h3>
              <van-tag :type="getStatusTagType(device.state)" size="small">{{ getStatusText(device.state) }}</van-tag>
              <van-tag :type="device.isOnlineAi ? 'success' : 'default'" size="small" style="margin-left: 8px;">
                {{ device.isOnlineAi ? 'AI在线' : 'AI离线' }}
              </van-tag>
              <van-tag :type="device.isOnlineFace ? 'success' : 'default'" size="small" style="margin-left: 8px;">
                {{ device.isOnlineFace ? '人脸在线' : '人脸离线' }}
              </van-tag>
            </div>
            <div class="device-actions">
              <van-button 
                size="mini" 
                type="primary"
                icon="video-o"
                class="video-button"
                @click.stop="goToVideoPreview(device)"
              >
                视频直播
              </van-button>
            </div>
          </div>
        </template>
        <template #desc>
          <div class="device-details">
            <div class="detail-row">
              <span class="label">设备编号：</span>
              <span class="value">{{ device.deviceSN }}</span>
            </div>
            <div class="detail-row">
              <span class="label">所属码头：</span>
              <span class="value">{{ getPortDesc(device.portCode) }}</span>
            </div>
            <div class="detail-row">
              <span class="label">心跳时间(AI)：</span>
              <span class="value">{{ formatDateTime(device.heatBeatTimeAi) }}</span>
            </div>
            <div class="detail-row">
              <span class="label">心跳时间(人脸)：</span>
              <span class="value">{{ formatDateTime(device.heatBeatTimeFace) }}</span>
            </div>
            <div class="detail-row">
              <span class="label">创建时间：</span>
              <span class="value">{{ formatDateTime(device.createTime) }}</span>
            </div>
            <div class="detail-row">
              <span class="label">摄像头数：</span>
              <span class="value">{{device.cameras.length }}</span>
              <van-button 
                size="mini" 
                type="primary"
                icon="setting-o"
                class="camera-manage-button" 
                @click.stop="goToCameraManagement(device)"
              >
                管理摄像头
              </van-button>
            </div>
          </div>
        </template>
      </van-card>
    </div>

    <!-- 空状态 -->
    <van-empty
      v-if="filteredDevices.length === 0"
      description="暂无设备数据"
    >
      <template #image>
        <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="60" cy="40" r="20" fill="none" stroke="#d9d9d9" stroke-width="3"/>
          <path d="M75 55 L85 65" stroke="#d9d9d9" stroke-width="3" stroke-linecap="round"/>
          <circle cx="60" cy="40" r="12" fill="none" stroke="#d9d9d9" stroke-width="1.5" stroke-dasharray="3 3"/>
        </svg>
      </template>
    </van-empty>

    <!-- 新增设备弹窗 -->
    <van-popup v-model="showAddDevice" position="bottom" :style="{ height: '60%' }" round>
      <div class="popup-header">
        <h3>添加设备</h3>
        <van-icon name="cross" @click="showAddDevice = false" />
      </div>
      <van-form @submit="onAddDevice" class="device-form">
        <van-field
          v-model="addDeviceForm.deviceSN"
          name="deviceSN"
          label="设备编号"
          placeholder="请输入设备编号"
          :rules="[{ required: true, message: '请输入设备编号' }]"
        />
        <van-field
          v-model="addDeviceForm.mac"
          name="mac"
          label="设备MAC"
          placeholder="请输入设备MAC"
          :rules="[{ required: true, message: '请输入设备MAC' }]"
        />
        <van-field
          v-model="addDeviceForm.mac2"
          name="mac2"
          label="设备MAC2"
          placeholder="(可空)请输入设备MAC2"
          :rules="[{ required: false, message: '请输入设备MAC2' }]"
        />
        <van-field
          v-model="addDeviceForm.deviceName"
          name="deviceName"
          label="设备名称"
          placeholder="请输入设备名称"
          :rules="[{ required: true, message: '请输入设备名称' }]"
        />
        <van-field
          name="portCode"
          label="所属码头"
          placeholder="请选择所属码头"
          readonly
          is-link
          v-model="addDeviceForm.portDesc"
          @click="showAddPortPicker = true"
          :rules="[{ required: true, message: '请选择所属码头' }]"
        />
        <div class="form-actions">
          <van-button
            round
            block
            type="primary"
            native-type="submit"
            :loading="addDeviceLoading"
          >
            确认添加
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <!-- 新增设备码头选择器 -->
    <van-popup v-model="showAddPortPicker" position="bottom">
      <van-picker
        :columns="portColumns"
        show-toolbar
        title="选择码头"
        @confirm="onAddPortConfirm"
        @cancel="showAddPortPicker = false"
      />
    </van-popup>

    <!-- 编辑设备弹窗 -->
    <van-popup v-model="showEditDevice" position="bottom" :style="{ height: '65%' }" round>
      <div class="popup-header">
        <h3>编辑设备</h3>
        <van-icon name="cross" @click="showEditDevice = false" />
      </div>
      <van-form class="device-form">
        <van-field
          v-model="editDeviceForm.deviceSN"
          name="deviceSN"
          label="设备编号"
          readonly
        />
        <van-field
          v-model="editDeviceForm.mac"
          name="mac"
          label="设备MAC"
          placeholder="请输入设备MAC"
          :rules="[{ required: true, message: '请输入设备MAC' }]"
        />
        <van-field
          v-model="editDeviceForm.mac2"
          name="mac2"
          label="设备MAC2"
          placeholder="(可空)请输入设备MAC2"
          :rules="[{ required: false, message: '请输入设备MAC2' }]"
        />
        <van-field
          v-model="editDeviceForm.deviceName"
          name="deviceName"
          label="设备名称"
          placeholder="请输入设备名称"
          :rules="[{ required: true, message: '请输入设备名称' }]"
        />
        <van-field
          name="portCode"
          label="所属码头"
          placeholder="请选择所属码头"
          readonly
          is-link
          v-model="editDeviceForm.portDesc"
          @click="showEditPortPicker = true"
          :rules="[{ required: true, message: '请选择所属码头' }]"
        />
        <van-field
          name="state"
          label="状态"
          placeholder="请选择状态"
          :readonly="!canEditState"
          is-link
          v-model="editDeviceForm.stateDesc"
          @click="onEditStateClick"
          :rules="[{ required: true, message: '请选择状态' }]"
        />
        <div class="form-actions">
          <van-button
            round
            block
            type="primary"
            :loading="editDeviceLoading"
            @click="onEditDevice"
          >
            保存修改
          </van-button>
        </div>
        <div class="danger-actions">
          <van-button
            round
            block
            type="danger"
            :loading="deleteDeviceLoading"
            @click="onDeleteDevice"
          >
            删除设备
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <!-- 编辑设备码头选择器 -->
    <van-popup v-model="showEditPortPicker" position="bottom">
      <van-picker
        :columns="portColumns"
        show-toolbar
        title="选择码头"
        @confirm="onEditPortConfirm"
        @cancel="showEditPortPicker = false"
      />
    </van-popup>
    <!-- 编辑设备状态选择器 -->
    <van-popup v-model="showEditStatePicker" position="bottom">
      <van-picker
        :columns="stateColumns"
        show-toolbar
        title="选择状态"
        @confirm="onEditStateConfirm"
        @cancel="showEditStatePicker = false"
      />
    </van-popup>

    <!-- 删除设备弹窗 -->
    <van-popup
      v-model="showDeleteDeviceConfirm"
      :style="{ width: '85%', borderRadius: '16px' }"
      round
      :close-on-click-overlay="false"
    >
      <div class="custom-confirm-dialog">
        <div class="confirm-icon">
          <van-icon
            :name="deleteDeviceConfirmConfig.icon"
            :color="deleteDeviceConfirmConfig.iconColor"
            size="48"
          />
        </div>
        <div class="confirm-title">
          {{ deleteDeviceConfirmConfig.title }}
        </div>
        <div class="confirm-message">
          {{ deleteDeviceConfirmConfig.message }}
        </div>
        <div class="confirm-actions">
          <van-button
            round
            size="small"
            plain
            @click="cancelDeleteDeviceConfirm"
            :disabled="deleteDeviceConfirmConfig.loading"
          >
            取消
          </van-button>
          <van-button
            round
            size="small"
            type="danger"
            :loading="deleteDeviceConfirmConfig.loading"
            @click="executeDeleteDeviceConfirm"
          >
            删除设备
          </van-button>
        </div>
      </div>
    </van-popup>
    </div>
  </van-pull-refresh>
</template>

<script>
import globalDic, { fetchMultiDic } from '@/utils/dic';
export default {
  name: 'DeviceManagement',
  data() {
    return {
      refreshing: false,
      searchKeyword: '',
      devices: [],
      // 新增设备相关
      showAddDevice: false,
      addDeviceForm: {
        deviceSN: '',
        deviceName: '',
        portCode: '',
        portDesc: '',
        mac: '',
        mac2: ''
      },
      showAddPortPicker: false,
      addDeviceLoading: false,
      // 编辑设备相关
      showEditDevice: false,
      editDeviceForm: {
        id: '',
        deviceSN: '',
        deviceName: '',
        portCode: '',
        portDesc: '',
        state: '',
        stateDesc: '',
        mac: '',
        mac2: ''
      },
      showEditPortPicker: false,
      showEditStatePicker: false,
      editDeviceLoading: false,
      deleteDeviceLoading: false,
      showDeleteDeviceConfirm: false,
      deleteDeviceConfirmConfig: {
        title: '删除设备',
        message: '确定要删除该设备吗？此操作不可恢复！',
        icon: 'delete-o',
        iconColor: '#ee0a24',
        buttonType: 'danger',
        buttonText: '删除设备',
        loading: false
      }
    };
  },
  computed: {
    isSuperAdmin() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return userInfo.roleID === 0;
    },
    portColumns() {
      return (globalDic.D_Port || []).map(item => item.description);
    },
    stateColumns() {
      return ['未绑定', '已禁用'];
    },
    filteredDevices() {
      let list = this.devices;
      if (this.searchKeyword) {
        const kw = this.searchKeyword.trim().toLowerCase();
        list = list.filter(device =>
          (device.deviceSN && device.deviceSN.toLowerCase().includes(kw)) ||
          (device.deviceName && device.deviceName.toLowerCase().includes(kw))
        );
      }
      // 在线的在上方，离线的在下方
      return list.slice().sort((a, b) => {
        return (b.isOnlineAi === true) - (a.isOnlineAi === true);
      });
    },
    canEditState() {
      return this.editDeviceForm.state === 0 || this.editDeviceForm.state === 2;
    }
  },
  async mounted() {
    if (!globalDic.D_Port || globalDic.D_Port.length === 0) {
      await fetchMultiDic(['D_Role', 'D_Port', 'D_AlarmType']);
    }
    this.loadDevices();
  },
  methods: {
    loadDevices() {
      this.$axios = this.$axios || require('@/utils/request').default;
      // 获取当前用户信息
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      let params = {};
      if (userInfo.roleID !== 0 && userInfo.portCode) {
        params.portCode = userInfo.portCode;
      }
      return this.$axios.post('/api/Device/Query', params)
        .then(res => {
          if (res && res.data && res.data.success) {
            this.devices = res.data.data || [];
          } else {
            this.$toast.fail('获取设备列表失败');
          }
        })
        .catch(() => {
          this.$toast.fail('获取设备列表失败');
        });
    },
    async onRefresh() {
      try {
        await this.loadDevices();
      } finally {
        this.refreshing = false;
      }
    },
    onSearch(value) {
      this.searchKeyword = value;
    },
    onClear() {
      this.searchKeyword = '';
    },
    getStatusText(state) {
      switch (Number(state)) {
        case 0: return '未绑定';
        case 1: return '绑定中';
        case 2: return '已禁用';
        case -1: return '已删除';
        default: return state;
      }
    },
    getStatusTagType(state) {
      switch (Number(state)) {
        case 0: return 'primary';
        case 1: return 'success';
        case 2: return 'danger';
        case -1: return 'default';
        default: return 'default';
      }
    },
    getPortDesc(portCode) {
      const dic = globalDic.D_Port || [];
      const found = dic.find(item => item.code === portCode);
      return found ? found.description : portCode;
    },
    getPortCodeByDesc(desc) {
      const dic = globalDic.D_Port || [];
      const found = dic.find(item => item.description === desc);
      return found ? found.code : '';
    },
    formatDateTime(str) {
      if (!str) return '';
      const d = new Date(str);
      if (isNaN(d.getTime())) return str;
      return d.getFullYear() + '-' + (d.getMonth()+1).toString().padStart(2,'0') + '-' + d.getDate().toString().padStart(2,'0') + ' ' + d.getHours().toString().padStart(2,'0') + ':' + d.getMinutes().toString().padStart(2,'0') + ':' + d.getSeconds().toString().padStart(2,'0');
    },
    goToVideoPreview(device) {
      this.$router.push({
        name: 'VideoPreview',
        params: { deviceId: device.deviceSN, mac: device.mac, mac2: device.mac2 }
      });
    },
    goToCameraManagement(device) {
      this.$router.push({
        name: 'CameraManagement',
        params: { deviceId: device.deviceSN, mac: device.mac, mac2: device.mac2, isOnlineAi: device.isOnlineAi }
      });
    },
    // 新增设备相关
    onAddPortConfirm(value) {
      this.addDeviceForm.portDesc = value;
      this.addDeviceForm.portCode = this.getPortCodeByDesc(value);
      this.showAddPortPicker = false;
    },
    onAddDevice(values) {
      this.addDeviceLoading = true;
      this.$axios = this.$axios || require('@/utils/request').default;
      this.$axios.post('/api/Device/Add', {
        deviceSN: this.addDeviceForm.deviceSN,
        deviceName: this.addDeviceForm.deviceName,
        portCode: this.addDeviceForm.portCode,
        mac: this.addDeviceForm.mac,
        mac2:this.addDeviceForm.mac2
      }).then(res => {
        if (res && res.data && res.data.success) {
          this.$toast.success('设备添加成功');
          this.showAddDevice = false;
          this.addDeviceForm = { deviceSN: '', deviceName: '', portCode: '', portDesc: '' };
          this.loadDevices();
        } else {
          this.$toast.fail(res.data.message || '设备添加失败');
        }
      }).catch(() => {
        this.$toast.fail('设备添加失败');
      }).finally(() => {
        this.addDeviceLoading = false;
      });
    },
    // 编辑设备相关
    onDeviceClick(device) {
      // 只允许超级管理员编辑
      if (!this.isSuperAdmin) return;
      if (device.state !== 0 && device.state !== 2) {
        this.$toast('当前设备处于绑定中状态，禁止修改设备信息');
        return;
      }
      this.editDeviceForm = {
        id: device.id,
        deviceSN: device.deviceSN,
        deviceName: device.deviceName,
        portCode: device.portCode,
        mac: device.mac,
        mac2: device.mac2,
        portDesc: this.getPortDesc(device.portCode),
        state: device.state,
        stateDesc: this.getStatusText(device.state)
      };
      this.showEditDevice = true;
    },
    onEditPortConfirm(value) {
      this.editDeviceForm.portDesc = value;
      this.editDeviceForm.portCode = this.getPortCodeByDesc(value);
      this.showEditPortPicker = false;
    },
    onEditStateClick() {
      if (!this.canEditState) {
        this.$toast('当前状态不能修改');
        return;
      }
      this.showEditStatePicker = true;
    },
    onEditStateConfirm(value) {
      this.editDeviceForm.stateDesc = value;
      this.editDeviceForm.state = value === '未绑定' ? 0 : 2;
      this.showEditStatePicker = false;
    },
    onEditDevice() {
      this.editDeviceLoading = true;
      this.$axios = this.$axios || require('@/utils/request').default;
      this.$axios.post('/api/Device/Modify', {
        id: this.editDeviceForm.id,
        deviceName: this.editDeviceForm.deviceName,
        portCode: this.editDeviceForm.portCode,
        state: this.editDeviceForm.state,
        mac: this.editDeviceForm.mac,
        mac2: this.editDeviceForm.mac2
      }).then(res => {
        if (res && res.data && res.data.success) {
          this.$toast.success('设备修改成功');
          this.showEditDevice = false;
          this.loadDevices();
        } else {
          this.$toast.fail(res.data.message || '设备修改失败');
        }
      }).catch(() => {
        this.$toast.fail('设备修改失败');
      }).finally(() => {
        this.editDeviceLoading = false;
      });
    },
    onDeleteDevice() {
      this.deleteDeviceConfirmConfig.loading = false;
      this.showDeleteDeviceConfirm = true;
    },
    cancelDeleteDeviceConfirm() {
      this.showDeleteDeviceConfirm = false;
    },
    executeDeleteDeviceConfirm() {
      if (this.deleteDeviceConfirmConfig.loading) return;
      this.deleteDeviceConfirmConfig.loading = true;
      this.$axios = this.$axios || require('@/utils/request').default;
      this.$axios.post('/api/Device/Delete', {
        id: this.editDeviceForm.id
      }).then(res => {
        if (res && res.data && res.data.success) {
          this.$toast.success('设备删除成功');
          this.showDeleteDeviceConfirm = false;
          this.showEditDevice = false;
          this.loadDevices();
        } else {
          this.$toast.fail(res.data.message || '设备删除失败');
        }
      }).catch(() => {
        this.$toast.fail('设备删除失败');
      }).finally(() => {
        this.deleteDeviceConfirmConfig.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.device-management {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: 100%;
}

.page-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 24px;
  border-radius: 28px;
  color: #fff;
  background: linear-gradient(135deg, var(--surface-strong) 0%, var(--brand-500) 65%, #6caeff 100%);
  box-shadow: 0 22px 50px rgba(15, 79, 185, 0.2);
}

.page-hero__copy h2 {
  font-size: 28px;
  line-height: 1.18;
  margin-bottom: 10px;
}

.page-hero__copy p {
  max-width: 680px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.75;
}

.page-hero__eyebrow {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.page-hero__meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.meta-pill {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  font-size: 13px;
  font-weight: 700;
}

.meta-pill--soft {
  background: rgba(255, 255, 255, 0.1);
}

.toolbar-card,
.device-card {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(215, 229, 251, 0.96);
  box-shadow: var(--shadow-card);
}

.toolbar-card {
  padding: 10px;
  border-radius: 24px;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px;
  border-bottom: 1px solid #ebedf0;
}
.popup-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}
.popup-header .van-icon {
  font-size: 22px;
  color: var(--text-muted);
  cursor: pointer;
}

.search-bar-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.device-search {
  flex: 1;
}
.device-search :deep(.van-search__content) {
  min-height: 34px;
  padding: 0 10px;
}
.device-search :deep(.van-field__control) {
  min-height: 6px;
  padding: 0;
}
.add-device-icon-btn {
  padding: 0 12px;
  min-width: 44px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-text {
  margin-left: 4px;
}

.device-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
}
.device-card {
  border-radius: 24px;
  overflow: hidden;
  padding: 14px;
}
.detail-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
}
.device-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
  width: 100%;
}
.device-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.device-id {
  font-size: 18px;
  color: var(--text-primary);
  margin-right: 4px;
}
.device-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
}
.video-button {
  margin-bottom: 4px;
}
.device-details {
  padding-top: 8px;
}
.label {
  color: var(--text-secondary);
  width: 92px;
  flex-shrink: 0;
}
.value {
  color: var(--text-primary);
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  word-break: break-all;
}
.form-actions {
  margin-top: 24px;
}
.danger-actions {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebedf0;
  display: flex;
  gap: 12px;
  justify-content: center;
}
.danger-actions .van-button {
  flex: 1;
  max-width: 120px;
}
.device-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
.footer-actions {
  display: flex;
  gap: 8px;
}
.video-button {
  margin-right: 8px;
}
.camera-manage-button {
  margin-left: 8px;
}

/* 自定义弹窗样式 */
.custom-confirm-dialog {
  padding: 32px 24px 24px;
  text-align: center;
  background: white;
  border-radius: 16px;
}
.confirm-icon {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}
.confirm-title {
  font-size: 18px;
  font-weight: bold;
  color: #323233;
  margin-bottom: 12px;
}
.confirm-message {
  font-size: 14px;
  color: #646566;
  line-height: 1.5;
  margin-bottom: 24px;
}
.confirm-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}
.confirm-actions .van-button {
  min-width: 80px;
  height: 36px;
}

@media (max-width: 767px) {
  .device-management {
    gap: 14px;
  }

  .page-hero {
    padding: 18px;
    border-radius: 24px;
    flex-direction: column;
  }

  .page-hero__copy h2 {
    font-size: 22px;
  }

  .page-hero__meta,
  .search-bar-row,
  .device-header {
    flex-direction: column;
    align-items: stretch;
  }

  .toolbar-card {
    padding: 8px 12px;
  }

  .add-device-icon-btn {
    width: 100%;
  }

  .device-list {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .btn-text {
    display: inline;
  }
}

@media (min-width: 768px) {
  .btn-text {
    display: inline;
  }
}
</style>
